<script setup>
import {onUnmounted, onMounted, reactive, watch} from 'vue'
import {State, clone, fixShadow, getModels, getRoute} from '@/paks/vu-app'
import Board from './Board.vue'
import {getView} from './BoardUtils'

const props = defineProps({
    refresh: Number,
    view: Object,
})

const page = reactive({
    board: null,
    design: null,
    key: 0,
    options: {expand: false},
    view: null,
})

defineExpose({page})

const {Dashboard} = getModels()

watch(() => State.app.needs.reload, (v) => v && reload())

onMounted(() => {
    reload()
})

function reload() {
    let qpath = getRoute().query?.path
    let view
    if (qpath) {
        view = getView(qpath).view
        //  Design mode
        page.design = true
    } else {
        //  Live page mode
        view = getView(getRoute().path).view
        page.design = false
    }
    if (!view) return
    page.view = clone(view)
    page.board = page.view.board || {
        widgets: [],
        widgetCss: [],
        css: [],
        layout: 'grid',
        fixed: true,
        framed: true,
        toolbar: true,
        type: 'page',
    }
    // REPAIR
    page.board.fixed = true
    page.board.type = 'page'
}

onUnmounted(() => {
    fixShadow()
})
</script>

<template>
    <Board
        v-if="page.board"
        v-model="page.board"
        :design="page.design"
        :options="page.options"
        :refresh="props.refresh"
        :type="'page'"
        :view="page.view" />
</template>
